import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { LanguageOptions } from '../../entities/LanguageOptions';
import { Availability } from '../../entities/Availability';
import { toast } from 'react-toastify';
import { Form, Row, Col } from 'react-bootstrap';
import { FormLayout, FormSection, FormField } from '../../shared/ui/FormLayout';

const CreateFormatPage = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    availability: {
      availableInAllCountries: true,
      allowedCountriesIds: [],
      disallowedCountriesIds: [],
    },
    title: '',
    mainLanguageId: 1,
  });

  const handleSubmit = async () => {
    if (!form.title.trim()) { toast.error('Введите название'); return; }
    setSaving(true);
    try {
      await apiRequests.events.createFormat(form);
      toast.success('Формат создан');
      navigate('/events/formats');
    } catch { toast.error('Ошибка'); } finally { setSaving(false); }
  };

  return (
    <FormLayout onSubmit={handleSubmit} onBack={() => navigate('/events/formats')} saving={saving} submitText="Создать">
      <FormSection title="Основная информация">
        <Row>
          <Col md={6}>
            <FormField label="Заголовок" required>
              <Form.Control type="text" value={form.title} onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))} />
            </FormField>
          </Col>
          <Col md={6}>
            <LanguageOptions onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: val }))} />
          </Col>
        </Row>
      </FormSection>
      <FormSection title="Доступность">
        <Availability
          onSelect={(val) => setForm((prev) => ({ ...prev, availability: { ...prev.availability, availableInAllCountries: val } }))}
          onSelectAllowed={(val) => setForm((prev) => ({ ...prev, availability: { ...prev.availability, allowedCountriesIds: val } }))}
          onSelectDisallowed={(val) => setForm((prev) => ({ ...prev, availability: { ...prev.availability, disallowedCountriesIds: val } }))}
        />
      </FormSection>
    </FormLayout>
  );
};

export default CreateFormatPage;
